import React from "react";
import './styles/Legal.css';

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms and Conditions</h1>
      <h1 className="terms-subtitle">Newro (Operated by NWRWTS Pty Ltd) </h1>
      <p className="terms-updated">Last updated: June 4, 2025</p>
      <p className="terms-updated">Jurisdiction: South Africa (POPIA-compliant), with international application</p>
      <h2 className="terms-section">1. Acceptance of Terms </h2>
      <p className="terms-text">
        By accessing or using Newro (the "Platform"), operated by NWRWTS Pty Ltd (referred to as “Newro”, "we", "us", or "our"), you ("you" or "the user") agree to be bound by these Terms & Conditions ("Terms"), our Privacy Policy, and any other legal notices published by us. If you do not agree, you must not access or use the Platform. </p>
      <h2 className="terms-section">2. Eligibility </h2>
      <p className="terms-text">
        To use the Platform, you must:
        <ul className="terms-list">
          <li> Have the legal capacity to enter into a binding agreement</li>
          <li> Agree to comply with all applicable laws and regulations</li>
        </ul>
        We may, at our sole discretion, refuse access to any user or terminate accounts for violations of these Terms. </p>
      <h2 className="terms-section">3. Account Registration </h2>
      <p className="terms-text">
        To host or participate in events on Newro, you must register for a user account. By registering, you agree to provide accurate, current, and complete information and to update this information as needed to maintain its accuracy.
        You are solely responsible for safeguarding your account credentials and for all activities that occur under your account. Newro will not be held liable for any loss or damage resulting from unauthorized access to or use of your account.
      </p>
      <h2 className="terms-section">4. User Responsibilities </h2>
      <p className="terms-text">
        By using the Platform, you agree:
        <ul className="terms-list">
          <li> Not to engage in harmful, fraudulent, or unlawful activities</li>
          <li> Not to impersonate another person or misrepresent your identity</li>
          <li> Not to spam, harass, or abuse other users</li>
          <li> To ensure your own safety and wellbeing during participation in events</li>
          <li> To follow event-specific guidelines provided by the host</li>
        </ul>
      </p>
      <h2 className="terms-section">5. Hosting Events </h2>
      <p className="terms-text">
        If you host an event:
        <ul className="terms-list">
          <li> You must describe the event accurately, including location, timing, required fitness level, and any known risks.</li>
          <li> You are responsible for the safety, accessibility, and conduct of the event.</li>
          <li> You acknowledge that you are not acting as an agent or employee of Newro.</li>
          <li> You agree not to charge participants through the Platform unless such functionality is introduced officially. - You agree to comply with all applicable public health, safety, and legal guidelines.</li>
        </ul>
        We reserve the right to remove any event listing or suspend hosting privileges for violations of these Terms. </p>
      <h2 className="terms-section">6. Participation & Assumption of Risk </h2>
      <p className="terms-text">
        All physical activities involve inherent risk.
        By joining or participating in an event, you acknowledge and voluntarily accept all risks associated with participation, including but not limited to injury, illness, or death.
        You agree that NWRWTS Pty Ltd and its affiliates are not liable for any harm, damage, or loss arising from your participation in any event. </p>
      <h2 className="terms-section">7. Location and Fitness Data </h2>
      <p className="terms-text">
        By using Newro:
        <ul className="terms-list">
          <li>You consent to the use of location services to personalize your experience and suggest relevant events.</li>
          <li>You agree to the collection of fitness-related data (such as preferences, activity types, etc.) to improve your experience.</li>
          <li>All data is processed and stored in compliance with POPIA and applicable international laws. See our Privacy Policy for full details.</li>
        </ul>
      </p>
      <h2 className="terms-section">8. User Content </h2>
      <p className="terms-text">
        You may post content such as profile information, event descriptions, comments, and photos ("User Content").
        You retain ownership of your content, but you grant us a worldwide, non-exclusive, royalty-free license to use, display, reproduce, and distribute it on the Platform.
        You are solely responsible for your content and agree not to post anything that is defamatory, illegal, obscene, or infringes on the rights of others.
        We reserve the right to remove or moderate content at our sole discretion. </p>
      <h2 className="terms-section">9. Code of Conduct </h2>
      <p className="terms-text">
        Users must:
        <ul className="terms-list">
          <li>Avoid hate speech, discrimination, or harassment of any kind</li>
          <li>Comply with all safety regulations</li>
          <li>Report inappropriate behavior or misuse to our support team</li>
        </ul>
        Violations may result in temporary suspension or permanent termination of accounts.
      </p>
      <h2 className="terms-section">10. Intellectual Property </h2>
      <p className="terms-text">
        All intellectual property on the Platform (excluding User Content) is owned by NWRWTS Pty Ltd. - This includes but is not limited to the platform design, logos, software, and content. - You may not copy, distribute, or exploit any portion of the Platform without our express written permission. </p>
      <h2 className="terms-section">11. Third-Party Links and Services </h2>
      <p className="terms-text">
        The Platform may contain links to third-party websites or services not owned or controlled by us. - We are not responsible for the content, policies, or practices of third-party services. </p>
      <h2 className="terms-section">12. Disclaimers </h2>
      <p className="terms-text">
        We make no guarantees about the availability, functionality, or reliability of the Platform or events hosted on it.
        We do not verify or endorse any hosts or event participants.
        The Platform is provided "as is" and "as available." </p>
      <h2 className="terms-section">13. Limitation of Liability </h2>
      <p className="terms-text">
        To the maximum extent permitted by law:
        - NWRWTS Pty Ltd and its directors, employees, or affiliates shall not be liable for any indirect, incidental,
        special, or consequential damages, including personal injury, data loss, or loss of profits, arising from your use of the Platform or participation in any event. </p>
      <h2 className="terms-section">14. Indemnification </h2>
      <p className="terms-text">
        You agree to indemnify and hold harmless NWRWTS Pty Ltd, its officers, directors, employees, and agents from any claims, damages, liabilities, or expenses (including legal fees) arising out of:
        <ul className="terms-list">

          <li>Your use of the Platform</li>
          <li>Your participation or hosting of any event</li>
          <li>Your breach of these Terms</li>
        </ul>
      </p>
      <h2 className="terms-section">15. Termination </h2>
      <p className="terms-text">
        We may, at our discretion, suspend or terminate your account at any time, with or without notice, for any violation of these Terms or if your conduct may harm our users or reputation.
        You may terminate your account at any time by contacting support. </p>
      <h2 className="terms-section">16. Modifications </h2>
      <p className="terms-text">
        We reserve the right to update these Terms from time to time. Changes will be communicated via the Platform. Continued use after such changes constitutes your acceptance of the revised Terms. </p>
      <h2 className="terms-section">17. Governing Law and Jurisdiction </h2>
      <p className="terms-text">
        These Terms shall be governed by and interpreted in accordance with the laws of South Africa. Disputes may be brought before the courts of South Africa unless otherwise required by local law for international users.
      </p>
    </div>
  );
};

export default TermsOfUse;
